import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FormGroup, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../Styles/forms.css";

const PatientInfoForm = ( props ) => {
  const navigate = useNavigate();
  console.log(props);

const { onSubmit, enableReinitialize} = props;

	//console.log('selected Visit info', selectedVisit);

  console.log (props);

  let patientInfo = null;

  if (props.initialValues)
  {
  patientInfo = props.initialValues.patientInfo?.[0] || {};
	console.log('Patient info', patientInfo);
}
  
	const initialValues = {
    PATIENT_NAME: patientInfo?.PATIENT_NAME || "",
    PATIENT_AGE: patientInfo?.PATIENT_AGE || "",
    PATIENT_ADDRESS: patientInfo?.PATIENT_ADDRESS || "",
    PATIENT_PHONE: patientInfo?.PATIENT_PHONE || "",
    PATIENT_OCCUPATION: patientInfo?.PATIENT_OCCUPATION || "",
    EMAILID: patientInfo?.EMAILID || "",
    PATIENT_GENDER: patientInfo?.PATIENT_GENDER || "",
    PATIENT_DOB: patientInfo?.PATIENT_DOB ? patientInfo.PATIENT_DOB.substring(0, 10) : "",  // Format for input type="date"
    PATIENT_BLOODGRP: patientInfo?.PATIENT_BLOODGRP || "",
    PATIENT_MOBILE_NUM: patientInfo?.PATIENT_MOBILE_NUM || "",
  };

  

  const validationSchema = Yup.object().shape({
    PATIENT_NAME: Yup.string().required("Required"),
    PATIENT_AGE: Yup.number().positive("Invalid age").integer("Invalid age"),
    PATIENT_PHONE: Yup.string(),
    EMAILID: Yup.string(),
//    PATIENT_DOB: Yup.date(),
    // Add validations for other fields as needed
  });

  return (
    <div className="form-wrapper">
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values, actions) => {
        console.log(values);
        props.onSubmit(values);
        actions.setSubmitting(false);
      }}>
        <Form className="form-content">
          <FormGroup className="form-group">
            <label htmlFor="PATIENT_NAME" className="form-label">Name</label>
            <Field name="PATIENT_NAME" type="text" className="form-input" />
            <ErrorMessage name="PATIENT_NAME" component="div" className="error" />
          </FormGroup>
  
          <FormGroup className="form-group">
            <label htmlFor="PATIENT_AGE" className="form-label">Age</label>
            <Field name="PATIENT_AGE" type="number" className="form-input" />
            <ErrorMessage name="PATIENT_AGE" component="div" className="error" />
          </FormGroup>
  
          <FormGroup className="form-group">
            <label htmlFor="PATIENT_PHONE" className="form-label">Phone</label>
            <Field name="PATIENT_PHONE" type="text" className="form-input" />
            <ErrorMessage name="PATIENT_PHONE" component="div" className="error" />
          </FormGroup>
  
          <FormGroup className="form-group">
            <label htmlFor="EMAILID" className="form-label">Email</label>
            <Field name="EMAILID" type="email" className="form-input" />
            <ErrorMessage name="EMAILID" component="div" className="error" />
          </FormGroup>
  
          <FormGroup className="form-group">
            <label htmlFor="PATIENT_DOB" className="form-label">Date of Birth</label>
            <Field name="PATIENT_DOB" type="date" className="form-input" />
            <ErrorMessage name="PATIENT_DOB" component="div" className="error" />
          </FormGroup>
  
          <div className="form-buttons">
            <button type="button" className="btn-back" onClick={() => navigate(-1)}>Back</button>
            <button type="submit" className="btn-next">Next</button>
          </div>
        </Form>
      </Formik>
    </div>
  );

};

export default PatientInfoForm;
